// extracted by mini-css-extract-plugin
export default {"profileItem":"style_profileItem__AqyzR","profileItemContent":"style_profileItemContent__SpNmJ","profileText":"style_profileText__trPGM","rowSuspended":"style_rowSuspended__XPkRZ"};